import { HttpClient, HttpHeaders } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { catchError, Observable } from 'rxjs'
import { Backend } from 'src/app/shared/enums/enums'
import { Dictionary } from 'src/app/shared/models/main/dictionary'
import { DdcLoggerService } from '../log/ddc-logger.service'

export interface ExploreResponse {
  count: number
  next?: string
  previous?: string
  results: Dictionary[]
}

@Injectable({
  providedIn: 'root',
})
export class ExploreService {
  private readonly httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
    }),
    withCredentials: true,
  }

  constructor(
    private http: HttpClient,
    private logger: DdcLoggerService,
  ) {}

  get_academy_dictionaries_by_topic(
    topic: string,
    page: number = 1,
    pageSize: number = 10,
  ): Observable<ExploreResponse> {
    this.logger.info(`EXPLORE | get_academy_dictionaries_by_topic | page: ${page}`)

    return this.http
      .post<ExploreResponse>(
        `${Backend.HOST_CONTAINER + Backend.ACADEMY_DICTIONARIES}`,
        {
          topic: topic,
          page: page,
          page_size: pageSize,
        },
        this.httpOptions,
      )
      .pipe(
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'EXPLORE | get_academy_dictionaries_by_topic | catchError | errorMessage: ' +
              errorMessage,
          )
          throw error // Re-throw to allow proper error handling
        }),
      )
  }

  get_love_dictionaries(): Observable<ExploreResponse> {
    this.logger.info(`EXPLORE | get_love_dictionaries`)

    return this.http
      .get<ExploreResponse>(
        `${Backend.HOST_CONTAINER + Backend.LOVE_DICTIONARIES}`,
        this.httpOptions,
      )
      .pipe(
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'EXPLORE | get_love_dictionaries | catchError | errorMessage: ' + errorMessage,
          )
          throw error // Re-throw to allow proper error handling
        }),
      )
  }

  get_driving_license_dictionaries(): Observable<ExploreResponse> {
    this.logger.info(`EXPLORE | get_driving_license_dictionaries`)

    return this.http
      .get<ExploreResponse>(
        `${Backend.HOST_CONTAINER + Backend.DRIVING_LICENSE_DICTIONARIES}`,
        this.httpOptions,
      )
      .pipe(
        catchError((error: any) => {
          const errorMessage = error.error
          this.logger.error(
            'EXPLORE | get_driving_license_dictionaries | catchError | errorMessage: ' +
              errorMessage,
          )
          throw error // Re-throw to allow proper error handling
        }),
      )
  }
}
